<template>
    <b-modal size="md"
             centered
             hide-footer
             content-class="rounded-xl border-0 shadow-lg"
             v-bind:visible="value"
             v-on:hide="hideModal"
             v-on:cancel="hideModal"
             v-on:close="hideModal">
        <template v-slot:modal-title>
            <strong>
                服務分類一覽
            </strong>
        </template>

        <div class="text-center"
             v-if="categories.length === 0">
            <h5 class="font-weight-normal">
                暫無分類
            </h5>
            <button class="btn btn-sm btn-primary"
                    v-on:click="isAddNewCategoryModalOpen = true">
                立即新增？
            </button>
        </div>

        <div v-else>
            <p>
                339智能自助服務簡介網站以服務分類排列。如要調整網站上的服務排列，請調整以下分類之排列。
            </p>
            <div class="d-flex justify-content-between mb-3">
                <b-form-checkbox switch
                                 size="lg"
                                 v-model="isReorderServiceCategoriesAllowed"
                                 v-on:change="dragEnded">
                    <small>
                        排列分類
                    </small>
                </b-form-checkbox>

                <div>
                    <button class="btn btn-sm btn-primary"
                            v-on:click="isAddNewCategoryModalOpen = true">
                        新增分類
                    </button>
                </div>
            </div>

            <draggable class="list-group"
                       tag="div"
                       v-bind:disabled="!isReorderServiceCategoriesAllowed"
                       v-model="categoriesInComponent">
                <category-item v-for="category in categoriesInComponent"
                               v-bind:key="category._id"
                               v-bind:dragging="isReorderServiceCategoriesAllowed"
                               v-bind:category="category">
                </category-item>
            </draggable>
        </div>

        <modal-category v-model="isAddNewCategoryModalOpen"></modal-category>
    </b-modal>
</template>

<script>
    import {
        BModal,
        BFormCheckbox,
    } from "bootstrap-vue";
    import draggable from "vuedraggable";
    import ModalCategory from "./ModalCategory";
    import CategoryItem from "./ModalCategories/CategoryItem";

    export default {
        name: "ModalCategories",
        components: {
            BModal,
            BFormCheckbox,
            draggable,
            ModalCategory,
            CategoryItem,
        },
        props: {
            "value": {
                type: Boolean,
                default: false,
            },
        },
        data () {
            return {
                isAddNewCategoryModalOpen: false,
                isReorderServiceCategoriesAllowed: false,

                categoriesInComponent: [],
            };
        },
        computed: {
            categories () {
                return this.$store.state.data.categories;
            },
        },
        methods: {
            hideModal () {
                this.$emit("input", false);
            },

            async dragEnded (evt) {
                if (!evt) {
                    try {
                        await Promise.all(
                            this.categoriesInComponent
                                .slice(0)
                                .map(
                                    async ({ _id, order }, ind) => {
                                        if (order !== ind) {
                                            return this.$store.dispatch(
                                                "data/editCategory",
                                                {
                                                    _id,
                                                    "order": ind
                                                }
                                            );
                                        }
                                        return undefined;
                                    }
                                )
                        );
                    } catch (e) {
                        console.error(e);
                    }
                }
            },
        },
        mounted () {
            if (
                Array.isArray(this.categories) &&
                this.categories.length > 0
            ) {
                this.categoriesInComponent = this.categories;
            }
        },
        watch: {
            "categories" (newVal) {
                if (
                    Array.isArray(newVal) &&
                    newVal.length > 0
                ) {
                    this.categoriesInComponent = newVal;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>
